import React from "react";
import Page from "../common/page/Page.js";
import useTranslationFooter from "./useTranslationFooter.js";
import Careers from "./Careers.js";


export default function CareersPage(/*props*/) {
  const { t, loading: tLoading } = useTranslationFooter();

  return (

      <Page className="CareerPage">
        <Page.Title loading={tLoading}>
        {t("footer:footer_career_title")}
        </Page.Title>
        <Page.Content>
          <Careers/>
        </Page.Content>
      </Page>

  );
}

